import styled, { keyframes } from "styled-components";

const bounce = keyframes`
  0%   { transform: translateY(0); }
  20%  { transform: translateY(-6px); }
  40%  { transform: translateY(0); }
  60%  { transform: translateY(-3px); }
  80%  { transform: translateY(0); }
  100% { transform: translateY(0); }
`;

const StyledLink = styled.a`
  height: min-content;
  display: inline-block;
  font-size: 1.5rem;
  color: #d97706; /* base */
  text-decoration: none;
  font-weight: bold;
  transition:
    color 0.2s,
    border-bottom-color 0.2s;
  animation: ${bounce} 1.2s infinite;
  cursor: pointer;
  border-bottom: 2px solid #d97706;

  &:hover {
    color: #b45309; /* shade */
    animation: none;
  }
`;

/**
 * WhatsAppAnimatedLink
 * @param {string} email - User's email to include in the message
 * @param {string} messageContent - Message content after the email
 * @param {string} children - Link text (default: "Solicitar tema")
 * @param {object} rest - Other props for <a>
 */

const phone = process.env.REACT_APP_WHATSAPP_PHONE;
export default function WhatsAppAnimatedLink({
  email,
  messageContent,
  children = "Solicitar tema",
  ...rest
}) {
  const message = `Olá, meu email é: ${email}. ${messageContent}`;
  const link = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <StyledLink href={link} target="_blank" rel="noopener noreferrer" {...rest}>
      {children}
    </StyledLink>
  );
}
